import * as React from "react";
import {createRoot} from "react-dom/client";
import {MainProvider} from "./SessionControls/mainProvider";

// React 18
const container = document.getElementById("root");
const root = createRoot(container)

export function showRootComponent(component: React.ReactElement) {
    root.render(
        <MainProvider>
            {component}
        </MainProvider>
    )
}
